export enum PackageStatus {
  Active = 'Active',
  Deleted = 'Deleted',
  Reserved = 'Reserved',
  Locked = 'Locked',
}
